import { useCallback, useState } from 'react';

type UseOpenCloseToggle = (initialOpenState?: boolean) => {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
};

const useOpenCloseToggle: UseOpenCloseToggle = (initialOpenState = false) => {
  const [isOpen, setIsOpen] = useState(initialOpenState);

  const toggle = useCallback(() => setIsOpen((x) => !x), []);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return {
    isOpen,
    toggle,
    open,
    close,
  };
};

export default useOpenCloseToggle;
